import { Car16, Walk16 } from '@cian/ui-kit/icons';
import { UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import { ETransportType } from '../../../../types/newbuildingPromoBuilderOffers';
import * as styles from './styles.css';

interface IFromUndergroundProps {
  transportType: ETransportType;
  timeTo: string;
}

export function FromUndergroundTime({ transportType, timeTo }: IFromUndergroundProps) {
  const Icon = transportType === ETransportType.Walk ? Walk16 : Car16;

  return (
    <div className={styles['distance']} data-testid="from_underground_time">
      <div className={styles['icon']}>
        <Icon data-testid={`from_underground_time_icon_${transportType}`} color={'gray_icons_100'} />
      </div>
      <UIText2 color={'gray60_100'}>{timeTo}</UIText2>
    </div>
  );
}
